import { axiosInstance } from 'api/apiConfig'
import { useQuery, useMutation } from 'react-query'
import { objectToQueryString } from 'utils/object-to-query-string';

const cmowEmpList = async (params) => {
  const { data } = await axiosInstance.get(`/api/common/notification/v1.0/selectCmowLst${objectToQueryString(params)}`)
  return data
}

// 공유하기 받는사람
export const useCmowEmpList = (params, isInit) => {
  return useQuery(
    ['cmowEmpList'],
    () => cmowEmpList(params),
    {
      enabled: isInit,
    },
  )
}

//공유하기 저장
const cmowRegist = async (params) => {
  const { data } = await axiosInstance.post('/api/common/notification/v1.0/insertCmow', params);
  return data;
};

export const useCmowRegist = ({
  successHandler,
  errorHandler,
}) => {
  return useMutation((params) => cmowRegist(params), {
    onSuccess: ({ data }) => {
      successHandler(data);
    },
    onError: (error) => {
      errorHandler(error);
    },
  });
};